import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Star1 from '../Svgs/Star1';
import Star2 from '../Svgs/Star2';

// Styles
import styles from './style.module.scss';

// Assets
// import ProcessingMascot from "../assets/processing_mascot.png";
import Logo from "../assets/logo.png";

// Hooks
import useIsDarkMode from '../../utils/hooks/darkMode';
import Typography from '../Typography';

interface ProcessingComponentProps {
  message?: string;
}

const ProcessingComponent: React.FC<ProcessingComponentProps> = ({ message }) => {

  const { t } = useTranslation();

  // Hooks
  const isDarkMode = useIsDarkMode();

  const _message = message || t('processingModal.description');

  return (
    <div className={styles.root}>
      <Star1 className={styles.star1} opacity={isDarkMode ? 0.05 : 1} />
      <Star2 className={styles.star2} opacity={isDarkMode ? 0.05 : 1} />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {t('processingModal.title')}
        </h1>

        <img src={Logo} alt="Processing Logo" className={styles.mascot} />

        <Typography variant="p" className={styles.description}>
          {_message}
        </Typography>
      </div>
    </div>
  )
}

export default ProcessingComponent;
